export const projectName = () => {
  document.title = "TrackMyTree";
  return "TrackMyTree";
};
